/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  branch Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    ADD_BLACK_LIST(state, blackList) {
      state.blackLists.unshift(blackList);
      state.totalDataRow++;
    },
    SET_BLACK_LIST(state, res) {
      state.blackLists = res.items
      state.totalDataRow = res.totalCount;
    },
    UPDATE_BLACK_LIST(state, blackList) {
      const productIndex = state.blackLists.findIndex((p) => p.id == blackList.id)
      Object.assign(state.blackLists[productIndex], blackList)
    },
    REMOVE_BLACK_LIST(state, blackListId) {
      const blackListIndex = state.blackLists.findIndex((p) => p.id == blackListId)
      state.blackLists.splice(blackListIndex, 1)
    },
  }
  